var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../content/form.html"] = require( "../content/form.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/treeview.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../content/form.html", false, "views/content/treeview.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("form", t_1);
output += "\r\n\r\n";
output += "\r\n";
var macro_t_4 = runtime.makeMacro(
["parent"], 
[], 
function (l_parent, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("parent", l_parent);
var t_5 = "";t_5 += "\r\n\t";
frame = frame.push();
var t_8 = l_parent;
if(t_8) {var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("branch", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\r\n\t\t";
if(runtime.memberLookup((t_9),"children")) {
t_5 += "\r\n\t\t\t<div class='branch ";
t_5 += runtime.suppressValue((!runtime.memberLookup((t_9),4)?"collapsed":""), env.opts.autoescape);
t_5 += "' data-tree-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),1), env.opts.autoescape);
t_5 += "\">\r\n\t\t\t\t<div data-window-tree-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),1), env.opts.autoescape);
t_5 += "\" class='branch-name ";
t_5 += runtime.suppressValue((runtime.memberLookup((t_9),"Selected")?"selected":""), env.opts.autoescape);
t_5 += "'>\r\n\t\t\t\t\t";
if(runtime.memberLookup((t_9),3) != runtime.contextOrFrameLookup(context, frame, "undefined")) {
t_5 += " \r\n\t\t\t\t\t<label class=\"table-cell field checkbox\">\r\n\t\t\t\t\t\t<input name=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),1), env.opts.autoescape);
t_5 += "\" type=\"checkbox\" ";
t_5 += runtime.suppressValue(((runtime.memberLookup((t_9),3))?"checked":""), env.opts.autoescape);
t_5 += "\r\n\t\t\t\t\t\t<span>&nbsp;";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),0), env.opts.autoescape);
t_5 += "</span>\r\n\t\t\t\t\t</label>\r\n\t\t\t\t\t";
;
}
else {
t_5 += "\r\n\t\t\t\t\t<span data-window-event=\"opentree:";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),1), env.opts.autoescape);
t_5 += "\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),0), env.opts.autoescape);
t_5 += "</span>\r\n\t\t\t\t\t";
;
}
t_5 += "\t\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"branches\">\r\n\t\t\t\t\t";
t_5 += runtime.suppressValue((lineno = 23, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "makeBranch"), "makeBranch", context, [runtime.memberLookup((t_9),"children")])), env.opts.autoescape);
t_5 += "\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t";
;
}
else {
t_5 += "\r\n\t\t\t<div data-window-tree-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),1), env.opts.autoescape);
t_5 += "\" class='stick ";
t_5 += runtime.suppressValue((runtime.memberLookup((t_9),"Selected")?"selected":""), env.opts.autoescape);
t_5 += "'>\r\n\t\t\t\t";
if(runtime.memberLookup((t_9),3) != runtime.contextOrFrameLookup(context, frame, "undefined")) {
t_5 += " \r\n\t\t\t\t<label class=\"table-cell field checkbox\">\r\n\t\t\t\t\t<input name=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),1), env.opts.autoescape);
t_5 += "\" type=\"checkbox\" ";
t_5 += runtime.suppressValue(((runtime.memberLookup((t_9),3))?"checked":""), env.opts.autoescape);
t_5 += "\r\n\t\t\t\t\t<span>&nbsp;";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),0), env.opts.autoescape);
t_5 += "</span>\r\n\t\t\t\t</label>\r\n\t\t\t\t";
;
}
else {
t_5 += "\r\n\t\t\t\t<span data-window-event=\"opentree:";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),1), env.opts.autoescape);
t_5 += "\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),0), env.opts.autoescape);
t_5 += "</span>\r\n\t\t\t\t";
;
}
t_5 += "\t\r\n\t\t\t</div>\r\n\t\t";
;
}
t_5 += "\r\n\t";
;
}
}
frame = frame.pop();
t_5 += "\r\n";
;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
context.addExport("makeBranch");
context.setVariable("makeBranch", macro_t_4);
output += "\r\n\r\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"editItems")) {
output += "\r\n<div class=\"action-bar sticky-div\">\r\n\t<div class=\"buttons\">\r\n\t\t<button class=\"button button-default\" data-window-event=\"saveTreeView\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Save"), env.opts.autoescape);
output += "</button>\r\n\t\t<button class=\"button button-default\" data-window-event=\"cancelTreeView\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Cancel"), env.opts.autoescape);
output += "</button>\r\n\t</div>\r\n</div>\r\n";
;
}
output += "\r\n\r\n<div class=\"tree-view\">\r\n\t<div class=\"content\">\r\n\t\t<div class=\"tree-view smaller\">\r\n\t\t\t\t";
output += runtime.suppressValue((lineno = 53, colno = 15, runtime.callWrap(macro_t_4, "makeBranch", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"tree")])), env.opts.autoescape);
output += "\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/treeview.html"] , dependencies)